import SectionHeading from '../shared/SectionHeading'
import styles from './styles.module.scss'

const STEPS = [
  ['エリアを確認', '日本地図から不足エリアをチェック'],
  ['フォーム送信', '紹介したい店舗・施設を送信'],
  ['店舗審査', '審査通過の場合ecboよりご連絡'],
  ['導入・掲載開始', '店舗がecbo cloakを導入'],
  ['特典をお支払い', '紹介者・導入店舗に特典をお渡し'],
]

const IntroductionFlowSection = (): JSX.Element => (
  <section className={`${styles.block} ${styles.flow}`}>
    <div className={`${styles.content} ${styles.center}`}>
      <SectionHeading
        variant="inverse"
        eyebrow="紹介の流れ"
        title="紹介はかんたん、あとはお任せください"
        description="フォーム送信後、ecbo担当者にて審査を行います。通過した場合は、導入・掲載まで丁寧にサポートいたします。"
      />
      <div className={styles.flowSteps}>
        {STEPS.map(([title, text], index) => (
          <div className={`${styles.flowStep} ${styles.reveal}`} data-reveal="" key={title}>
            <div>{index + 1}</div>
            <span className={styles.flowText}>
              <h3>{title}</h3>
              <p>{text}</p>
            </span>
          </div>
        ))}
      </div>
    </div>
  </section>
)

export default IntroductionFlowSection
